import React, { useState } from 'react';
import { Box, Typography, Paper, RadioGroup, FormControlLabel, Radio, Button } from '@mui/material';
import { UserProfile } from '../../types/UserProfile';

interface LibrarySettingsProps {
  profile: UserProfile;
  onSave: (updatedProfile: UserProfile) => Promise<void>;
}

const ORDER_OPTIONS: { value: 'ps' | 'up'; title: string; description: string }[] = [
  {
    value: 'ps',
    title: 'プレイ開始日（デフォルト）',
    description: '最近プレイを始めたゲームから順に並びます。プレイ開始日が設定されていないゲームは更新日順で並びます。',
  },
  {
    value: 'up',
    title: '更新日',
    description: 'スコアやレビューなどを含むステータス情報を編集したゲームが上に並びます。',
  },
];

const LibrarySettings: React.FC<LibrarySettingsProps> = ({ profile, onSave }) => {
  const [order, setOrder] = useState<'ps' | 'up'>(profile.personalize?.l?.o ?? 'ps');

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      const personalize = { ...profile.personalize };
      if (order === 'up') {
        personalize.l = { o: 'up' };
      } else {
        // 'ps'（デフォルト）はキーを持たせない（キー無し＝'ps'）
        delete personalize.l;
      }
      await onSave({ ...profile, personalize });
    } catch (error) {
      console.error('ライブラリ設定の更新に失敗しました', error);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', maxWidth: 600 }}>
      <Typography variant="h6" gutterBottom>
        ライブラリの並び順
      </Typography>
      <Paper elevation={0} sx={{ bgcolor: 'background.paper' }}>
        <Typography variant="body2" color="text.secondary" paragraph>
          ライブラリ画面で並び替えを指定していないときの表示順を変更できます。
        </Typography>
        <RadioGroup
          aria-label="library-order"
          name="library-order"
          value={order}
          onChange={(e) => setOrder(e.target.value as 'ps' | 'up')}
        >
          {ORDER_OPTIONS.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio />}
              sx={{ alignItems: 'flex-start', mb: 1.5, '& .MuiRadio-root': { pt: 0.5 } }}
              label={
                <Box>
                  <Typography variant="body2">{option.title}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {option.description}
                  </Typography>
                </Box>
              }
            />
          ))}
        </RadioGroup>
      </Paper>

      <Box mt={2}>
        <Button type="submit" variant="contained" color="primary" size="small">
          保存
        </Button>
      </Box>
    </Box>
  );
};

export default LibrarySettings;
